import React from 'react'
import ContentLoader from 'react-content-loader'
import { LoaderContainer } from './mixins'

export const CardPlaceholder = () => (
  <LoaderContainer>
    <ContentLoader
      speed={2}
      backgroundColor="#ebebeb"
      foregroundColor="#ecebeb"
      style={{ height: '172px', width: '100%' }}
    >
      <rect x="16" y="16" rx="8" ry="8" width="88" height="57" />
      <rect x="119" y="52" rx="0" ry="0" width="50%" height="14" />
      <rect x="16" y="122" rx="0" ry="0" width="75" height="14" />
      <rect x="46%" y="122" rx="0" ry="0" width="50%" height="14" />
      <rect x="119" y="23" rx="0" ry="0" width="55%" height="16" />
      <rect x="16" y="86" rx="0" ry="0" width="65%" height="18" />
      <rect x="0" y="149" rx="8" ry="8" width="100%" height="23" />
      <rect x="0" y="149" rx="0" ry="0" width="100%" height="10" />
    </ContentLoader>
  </LoaderContainer>
)
export default CardPlaceholder
